<template>
    <Table
        style="width: 100%"
        :data="data"
        class="table-striped"
        max-height="450"
        @row-click="onClick"
        aria-describedby="paymentListData"
        >
        <Table-column fixed>
            <template slot-scope="scope">
                {{scope.row.order_reference}}
            </template>
        </Table-column>
        <Table-column fixed>
            <template slot-scope="scope">
                {{scope.row.description}}
            </template>
        </Table-column>
    </Table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClick(item) {
      this.$emit('onClick', item);
    },
  },
};
</script>
